import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Grid,
  TextField,
  Button,
  TablePagination,
  FormControl,
  IconButton,
  Autocomplete,
  Radio,
  RadioGroup,
  Icon,
  Snackbar,
  Slide,
  Alert,
  styled,
  Backdrop,
  CircularProgress,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  TableContainer,
  Checkbox,
  InputAdornment,
} from "@material-ui/core";
import { Delete } from "@mui/icons-material";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import { CSVLink } from "react-csv";
import { formatDateTimeForBackend } from "../../Functions.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { ArrowBack, Error } from "@mui/icons-material";

import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { uploadAdditioalDocumentFile } from "../Invoices/actions";
import VendorFinancingTable from "./Tables/VendorFinancing_Table";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import VenderCode from "../Invoices/NewInvoice/Dropdowns/VenderCode";
import axios from "axios";
import getParameterByName, { getBankName } from "../../Functions/functions";
import CustomSnackbar from "../../CustomSnackbar";
import { getVendorDetail } from "../Invoices/actions";
import { getBankDetail, getLcsLandingPage } from "../VendorFinancingLc/actions";
import TableSkeleton from "../../StyledComponents/TableSkeleton";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const useStyles = makeStyles(dashboardStyle);
const commentBox = {
  fontFamily: "DM Sans,sans-serif",
  fontWeight: "400",
  fontSize: "0.875rem",
  width: "100%",
  border: "1px solid #b4b4b4",
  borderRadius: "2px",
  resize: "none",
  overflow: "hidden",
  outline: "none",
  height: 25,
  marginTop: "1px",
  color: "black",
};
const VendorFinancinglandingpage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [sumNetAmount, setSumNetAmount] = useState(0);
  const [sentToTreasury, setsentToTreasury] = useState(
    "yet to be sent to Treasury"
  );
  const [dragfile, setDragFile] = useState(false);
  const [file, setFile] = useState([]);
  const [sentTreasury,setSentTreasury]=useState(false)
  const [dragloader, setDragLoader] = useState(false);
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [attachmentLoader, setAttchmentLoader] = useState(false);
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );
  const vendorCode = getParameterByName("vendorCode");

  // const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [lcMessage, setLcMessage] = useState("");
  const [selectedLC, setSelectedLC] = useState([]);

  const [count, setCount] = useState(0);
  const [lccount, setLCCount] = useState(0);
  const [batchRef, setBatchRef] = useState([]);
  const [treasuryRef, setTreasuryRef] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [waitMessage, setWaitMessage] = useState("");
  const [sendloader, setSendloader] = useState(false);

  const [selectedCheckBoxId, setSelectedCheckBoxId] = useState(null);
  const [selectedLCAmount , setSelectedLCAmount]  = useState({})
  const [proceed, setProceed] = useState(false);

  const [treasuryState, setTreasuryState] = useState({
    invoices: [],
    treasury: "",
    remarks: "",
    LC_Id: ""
  });
  const [validate, setValidate] = useState(false);
  const [validatetreasury, setValidateTresaury] = useState(false);
  const [Invvalidate, setInvValidate] = useState(false);
  const [LadgerDataCSV, setLadgerDataCSV] = useState([{}]);
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [vendorblock, setvendorblock] = useState(false);
  const [vendorLcs, setLcs] = useState([]);
  const [lcLoading, setLcsLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [bankDetailsLoading, setBankDetailsLoading] = useState(false);

  const [formState, setFormState] = useState({
    clearingDateFrom: moment().subtract(3, "d").format("YYYY-MM-DD"),
    clearingDateTo: moment().format("YYYY-MM-DD"),
    batchFromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    batchToDate: moment().format("YYYY-MM-DD"),
    vendor_Code: "",
    batchRef: "",
    RowsOfPage: 25,
    PageNo: 0,
    LcRowsOfPage: 25,
    LCPageNo: 1,
  });

  const [docError, setDocError] = useState("");
  let DocDate = moment().format("YYYY"); ///for current year

  const [dataObject,setDataObject] = useState([]);

  const getVendorDetail = async (user) => {
    //
    await axios({
      method: "get", //you can set what request you want to be
      url: `${
        process.env.REACT_APP_API_URL
      }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setFormState((formState) => ({
          ...formState,
          vendor_Code: res.data[0],
        }));
      })
      .catch((err) => {
        // setErrorMessage("Invalid username or password");
      });
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
  
    const data = [
      ['', '', '', '', formState?.vendor_Code?.Vendor_Name],
      ['', 'Date', '', '', 'Vendor Financing', '', 'LC Limit', 'Utilized', 'Balance'],
      ['', new Date(), '', '', getBankName(bankDetails, selectedLC?.["bank_Id"]),'',selectedLC.lC_Amount,selectedLC.utilizes_Amount+sumNetAmount,selectedLC.available_Amount-sumNetAmount],
      // ['', '', '', '', selectedLC?.["lC_Id"],'','','',''],
      [], [], 
      ['S. #', 'Invoice Date', 'Invoice No.','Invoice Nature',
       'Amount Inclusive GST','Income Tax Deduction','Sales Tax Deduction', 'Net Amount',
       'Sent to Bank on', 'Payment days', 'Maturity on'],
      ...dataObject.map((row, index) => {
        function calculateMaturityDate(issuanceDate, maturityPeriod) {
          const issueDate = new Date(issuanceDate);
          issueDate.setDate(issueDate.getDate() + maturityPeriod);
          return issueDate;
        }
     
        const currentDate = new Date();
        const maturityPeriod = Number(selectedLC.maturity_Period);// Maturity period in days (e.g., 90 days)
        const maturityDate = calculateMaturityDate(currentDate, maturityPeriod);
        const formattedMaturityDate = maturityDate;
        const invoiceDate = new Date(row.Invoice_Date);
        const clearingDate = new Date();
        const timeDiff = clearingDate - invoiceDate; // Difference in milliseconds
        const daysRemaining = Math.floor(timeDiff / (1000 * 3600 * 24)); // Convert milliseconds to days

        return [
          index + 1,  // Serial number (1-based index)
          moment(row?.Invoice_Date).format("DD-MMM-YYYY"), // Invoice Date
          row.Invoice_No, // Invoice Number
          row.Invoice_Desc, // Invoice Nature
          parseFloat(row.INV_AMT), // Invoice Amount
          parseFloat(row.INC_TAX),// Income Tax Deduction
          parseFloat(row.WH_TAX), // Sales Tax Deduction
          parseFloat(row.NT_AMNT), // Net Amount
          new Date(), // Current Date
          daysRemaining, // Days Remaining
          formattedMaturityDate
        ];
      }), 
      [],
      ['','','TOTAL', "LC Reference#:"+" "+selectedLC.lC_Bank_Reference_num,dataObject.reduce((sum, row) => sum + parseFloat(row.INV_AMT), 0), dataObject.reduce((sum, row) => sum + parseFloat(row.INC_TAX), 0), dataObject.reduce((sum, row) => sum + parseFloat(row.WH_TAX), 0), dataObject.reduce((sum, row) => sum + parseFloat(row.NT_AMNT), 0)]
    ];

    data.forEach((row, rowIndex) => {
      const excelRow = worksheet.addRow(row);
      
      if ([0, data.length - 1].includes(rowIndex)) {
        excelRow.eachCell((cell)=>{
         if(typeof(cell.value) == "string"){
          cell.value = cell.value.toUpperCase()
         }
        })
        excelRow.font = { bold: true , size: 11, name: "Georgia"  };
      //   excelRow.alignment = {
      //     vertical: "center",
      // horizontal: "center"
      //   }
      }
      if ([ 1, 5, data.length - 1].includes(rowIndex)) {
        excelRow.font = { bold: true  , name: "Georgia" };
      }
      if ([2, data.length - 1].includes(rowIndex)) {
        excelRow.eachCell((cell , colIndex)=>{  
          console.log(cell.col, "col")          
if(cell.col === 2){
  cell.font = {bold : true}   
}   
        })

      row.forEach((cell, colIndex) => {
        const cellRef = excelRow.getCell(colIndex + 1);
  
        if (colIndex === 1 || colIndex === 11 || colIndex === 12) {
          cellRef.numFmt = 'dd-mmm-yy';
        }
  
        if ([5, 6, 7, 8].includes(colIndex) && typeof cell === 'number') {
          cellRef.numFmt = '#,##0.00'; 
        }
  
        if (colIndex === 10 && typeof cell === 'number') {
          cellRef.numFmt = '0';
        }

        if ((rowIndex === 0 || rowIndex === 1 ||  rowIndex === 2) && [0,1 , 2 ,  3, 4,  5].includes(colIndex)) {
          return; // Skip these cells
      }
        cellRef.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
  }})
  
    worksheet.columns = [
      { width: 10 },   // S. #
      { width: 12 },  // Invoice Date
      { width: 15 },  // Invoice No.
      { width: 25 },  // Invoice Nature
      { width: 20 },  // Amount Inclusive GST
      { width: 20 },  // Income Tax Deduction
      { width: 20 },  // Sales Tax Deduction
      { width: 18 },  // Net Amount
      { width: 15 },  // Sent to Bank on
      { width: 15 },  // Payment days
      { width: 15 }   // Maturity on
    ];
  
        const buffer = await workbook.xlsx.writeBuffer(); 
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    await saveAs(new Blob([buffer]), 'Vendor_Financing_Report.xlsx');
};

  // useEffect(()=>{
  //   sentTreasury && exportToExcel()
  // },[sentTreasury])
  useEffect(()=>{
   setDataObject([])
  },[])
  const GenerateDoc = async () => {
    if (clearingDoc == "") {
      setValidate(true);
    } else {
      setDocError("");
      setSendloader(true);
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GenerateVFPayments/${clearingDoc}/${DocDate}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .request(config)
        .then((response) => {
          setSendloader(false);
          getVendorDetail(response?.data?.VendorCode);
          setSuccessMessage("Document No Generated Successfully");
          setValidate(false);
          getInvoices();
        })
        .catch((error) => {
          setDocError(error?.response?.data?.Message);
         if(error?.response?.data?.VendorCode!==""){
          getVendorDetail(error?.response?.data?.VendorCode);
         }
          setSendloader(false);
        });
    }
  };
  const DelDoc = () => {
    if (clearingDoc == "") {
      setValidate(true);
    } else {
      setSendloader(true);
      setErrorMessage("");

      setDocError("");

      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/api/VFPayments/DeleteDocument/${clearingDoc}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .request(config)
        .then((response) => {
          setSendloader(false);
          setSuccessMessage("Document Deleted Successfully");
          setClearingDoc("");
          setValidate(false);
          getInvoices();
        })
        .catch((error) => {
          setDocError(error.response.data);
          setSendloader(false);
        });
    }
  };
  const [clearingDoc, setClearingDoc] = useState("");
  const gettaxTeamRef = async () => {
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/GetReferenceData/Treasury`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setTreasuryRef(res.data);
        // setTreasuryState((treasuryState) => ({
        //   ...treasuryState,
        //   ["treasury"]: res.data[0],
        // }));
      })
      .catch((err) => {});
  };

  const getInvoices = async () => {
    let URL;
    let params = {};
    setInvoiceLoading(true);

    if (sentToTreasury === "yet to be sent to Treasury") {
      params = {
        vendorCode: formState?.vendor_Code?.Vendor_Code,
        clearingDateFrom: formState.clearingDateFrom + "T00:00:00",
        clearingDateTo: formState.clearingDateTo + "T23:54:00",
        clearingDocumentNO: clearingDoc,
      };
    } else {
      params = {
        vendorCode: formState?.vendor_Code?.Vendor_Code,
        batchRef: formState?.batchRef?.BatchRef,
        batchFromDate: formState.batchFromDate + "T00:00:00",
        batchToDate: formState.batchToDate + "T23:54:00",
      };
    }
    Object.keys(params).forEach(
      (key) => params[key] === undefined && delete params[key]
    );

    URL = `${
      process.env.REACT_APP_API_URL
    }/api/VFPayments/GetInvoices?${new URLSearchParams(params)?.toString()}`;

    // if (sentToTreasury === "yet to be sent to Treasury") {
    //   URL = `${
    //     process.env.REACT_APP_API_URL
    //   }/api/VFPayments/GetInvoices?vendorCode=${
    //     formState?.vendor_Code?.Vendor_Code
    //   }&clearingDateFrom=${
    //     formState.clearingDateFrom + "T00:00:00"
    //   }&clearingDateTo=${formState.clearingDateTo + "T23:54:00"}&clearingDocumentNO=${clearingDoc}`;
    // } else {
    //   URL = `${
    //     process.env.REACT_APP_API_URL
    //   }/api/VFPayments/GetInvoices?vendorCode=${
    //     formState?.vendor_Code?.Vendor_Code
    //   }&batchRef=${formState?.batchRef?.BatchRef}&batchFromDate=${
    //     formState.batchFromDate + "T00:00:00"
    //   }&batchToDate=${formState.batchToDate + "T23:54:00"}`;
    // }

    const axios = require("axios");
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {
        setInvoiceLoading(false);
        if (sentToTreasury !== "sent to Treasury") {
          const filteredInvoices = response.data.filter((item) => !item.Batch_Id);
          setCount(filteredInvoices.length);
          setInvoices(filteredInvoices);
          setDataObject(filteredInvoices)
        } else {
          const newList = [];
          const groupedItems = {};

          for (const item of response.data) {
            const { BatchRef, Batch_Id, BatchDate, Vendor_Name, Comments } =
              item;
            const key = `${BatchRef}-${Batch_Id}-${BatchDate}-${Vendor_Name}-${Comments}`;

            if (!groupedItems[key]) {
              groupedItems[key] = {
                batchRef: BatchRef,
                batchNo: Batch_Id,
                batchDate: BatchDate,
                vendor_Name: Vendor_Name,
                comments: Comments,
                expand: false,
                invoices: [],
              };
              newList.push(groupedItems[key]);
            }

            groupedItems[key].invoices.push(item);
          }

          setCount(newList.length);
          setInvoices(newList);

          // setCount(response.data.length);
          // setInvoices(response.data);
        }

        setInvValidate(false);
        if (sentToTreasury !== "sent to Treasury") {
          setLadgerDataCSV(
            response.data
              ?.filter((item) => !item.Batch_Id)
              ?.map((item, id) => {
                return {
                  VendorName: item?.Vendor_Name,
                  InvoiceDate: moment(item?.Invoice_Date).format("YYYY-MM-DD"),
                  PostingDate: moment(item?.Posting_Date).format("YYYY-MM-DD"),
                  ClearingDocuments: item?.Document_No,
                  ClearingDate: moment(item?.Clearing_Date).format(
                    "YYYY-MM-DD"
                  ),
                  InvoiceNo: item?.Invoice_No,
                  InvoiceDescription: item?.Invoice_Desc,
                  InvoiceAmount: item?.INV_AMT,
                  ITWAmount: item?.INC_TAX,
                  STWAmount: item?.WH_TAX,
                  NetAmount: item?.NT_AMNT,
                  BatchReference: item?.Batch_Id,
                  BatchDate: item?.BatchDate,
                };
              })
          );
        } else {
          setLadgerDataCSV(
            response.data.map((item, id) => {
              return {
                VendorName: item?.Vendor_Name,
                InvoiceDate: moment(item?.Invoice_Date).format("YYYY-MM-DD"),
                PostingDate: moment(item?.Posting_Date).format("YYYY-MM-DD"),
                ClearingDocuments: item?.Document_No,
                ClearingDate: moment(item?.Clearing_Date).format("YYYY-MM-DD"),
                InvoiceNo: item?.Invoice_No,
                InvoiceDescription: item?.Invoice_Desc,
                InvoiceAmount: item?.INV_AMT,
                ITWAmount: item?.INC_TAX,
                STWAmount: item?.WH_TAX,
                NetAmount: item?.NT_AMNT,
                BatchReference: item?.Batch_Id,
                BatchDate: item?.BatchDate,
              };
            })
          );
        }
      })
      .catch((error) => {});
    setInvoiceLoading(true);
  };

  const updateVendorFinancing = async () => {
    const axios = require("axios");

    let config = {
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/api/VendorFinancing/UpdateVendorFinancing?lcId=${selectedLC?.lC_Id}&utilizesAmount=${sumNetAmount}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {
        console.log("updated successfully");
        if (formState?.vendor_Code?.Vendor_Code) {
          const newFormState = {
            ...formState,
            Vendor: formState?.vendor_Code,
            PageNo: formState?.LCPageNo,
            RowsOfPage: formState?.LcRowsOfPage,
          };
  
          setLcsLoading(true);
          getLcsLandingPage(setLcs, setLcsLoading, newFormState, setLCCount);
        }
        
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };
  const getBatchRef = async () => {
    const axios = require("axios");

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/api/VFPayments/GetBatch`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {
        setBatchRef(response.data);
        // setFormState((formState) => ({
        //   ...formState,
        //   ["batchRef"]: response.data[0],
        // }));
      })
      .catch((error) => {});
  };
  const headers = [
    { label: "Vendor Name", key: "VendorName" },
    { label: "Invoice Date", key: "InvoiceDate" },
    { label: "Posting Date", key: "PostingDate" },
    { label: "Clearing Documents", key: "ClearingDocuments" },
    { label: "Clearing Date", key: "ClearingDate" },
    { label: "Invoice No", key: "InvoiceNo" },
    { label: "Invoice Description", key: "InvoiceDescription" },
    { label: "Invoice Amount", key: "InvoiceAmount" },
    { label: "ITW Amount", key: "ITWAmount" },
    { label: "STW Amount", key: "STWAmount" },
    { label: "Net Amount", key: "NetAmount" },
    // sentToTreasury === "sent to Treasury" &&
    //   ({ label: "Batch Reference", key: "BatchReference" },
    //   { label: "Batch Date", key: "BatchDate" }),
  ];
  const csvReport = {
    filename: "Invoices.csv",
    headers: headers,
    data: LadgerDataCSV,
  };

  useEffect(() => {
    gettaxTeamRef();
  }, []);
  useEffect(() => {
    getBatchRef();
    setTreasuryState((treasuryState) => ({
      ...treasuryState,
      invoices: [],
    }));
  }, [sentToTreasury]);

  const PostTreasury = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
    
      const data = [
        ['', '', '', '', formState?.vendor_Code?.Vendor_Name],
        ['', 'Date', '', '', 'Vendor Financing', '', 'LC Limit', 'Utilized', 'Balance'],
        ['', new Date(), '', '', getBankName(bankDetails, selectedLC?.["bank_Id"]),'',selectedLC.lC_Amount,selectedLC.utilizes_Amount+sumNetAmount,selectedLC.available_Amount-sumNetAmount],
        [], [], 
        ['S. #', 'Invoice Date', 'Invoice No.','Invoice Nature',
         'Amount Inclusive GST','Income Tax Deduction','Sales Tax Deduction', 'Net Amount',
         'Sent to Bank on', 'Payment days', 'Maturity on'],
        ...dataObject.map((row, index) => {
          function calculateMaturityDate(issuanceDate, maturityPeriod) {
            const issueDate = new Date(issuanceDate);
            issueDate.setDate(issueDate.getDate() + maturityPeriod);
            return issueDate;
          }
       
          const currentDate = new Date();
          const maturityPeriod = Number(selectedLC.maturity_Period);// Maturity period in days (e.g., 90 days)
          const maturityDate = calculateMaturityDate(currentDate, maturityPeriod);
          const formattedMaturityDate = maturityDate;
          const invoiceDate = new Date(row.Invoice_Date);
          const clearingDate = new Date();
          const timeDiff = clearingDate - invoiceDate; // Difference in milliseconds
          const daysRemaining = Math.floor(timeDiff / (1000 * 3600 * 24)); // Convert milliseconds to days

          return [
            index + 1,  // Serial number (1-based index)
            moment(row?.Invoice_Date).format("DD-MMM-YYYY"), // Invoice Date
            row.Invoice_No, // Invoice Number
            row.Invoice_Desc, // Invoice Nature
            parseFloat(row.INV_AMT), // Invoice Amount
            parseFloat(row.INC_TAX),// Income Tax Deduction
            parseFloat(row.WH_TAX), // Sales Tax Deduction
            parseFloat(row.NT_AMNT), // Net Amount
            new Date(), // Current Date
            daysRemaining, // Days Remaining
            formattedMaturityDate
          ];
        }), 
        [],
        ['','','TOTAL', "LC Reference#:"+" "+selectedLC.lC_Bank_Reference_num,dataObject.reduce((sum, row) => sum + parseFloat(row.INV_AMT), 0), dataObject.reduce((sum, row) => sum + parseFloat(row.INC_TAX), 0), dataObject.reduce((sum, row) => sum + parseFloat(row.WH_TAX), 0), dataObject.reduce((sum, row) => sum + parseFloat(row.NT_AMNT), 0)]
      ];
    
      data.forEach((row, rowIndex) => {
        const excelRow = worksheet.addRow(row);
    
        if ([5, data.length - 1].includes(rowIndex)) {
          excelRow.font = { bold: true };
        }
    
        row.forEach((cell, colIndex) => {
          const cellRef = excelRow.getCell(colIndex + 1);
    
          if (colIndex === 1 || colIndex === 11 || colIndex === 12) {
            cellRef.numFmt = 'dd-mmm-yy';
          }
    
          if ([5, 6, 7, 8].includes(colIndex) && typeof cell === 'number') {
            cellRef.numFmt = '#,##0.00'; 
          }
    
          if (colIndex === 10 && typeof cell === 'number') {
            cellRef.numFmt = '0';
          }

          cellRef.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      });
    
      worksheet.columns = [
        { width: 10 },   // S. #
        { width: 12 },  // Invoice Date
        { width: 15 },  // Invoice No.
        { width: 25 },  // Invoice Nature
        { width: 20 },  // Amount Inclusive GST
        { width: 20 },  // Income Tax Deduction
        { width: 20 },  // Sales Tax Deduction
        { width: 18 },  // Net Amount
        { width: 15 },  // Sent to Bank on
        { width: 15 },  // Payment days
        { width: 15 }   // Maturity on
      ];
    
      const buffer = await workbook.xlsx.writeBuffer(); 
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
   setFile(new File([blob], 'Vendor_Financing_Report.xlsx', { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  

    setSentTreasury(true)
    if (!treasuryState.treasury) {
      setValidateTresaury(true);
    } else if (treasuryState?.invoices.length === 0) {
      setInvValidate(true);
    } else if (sumNetAmount <= 0 && treasuryState.invoices?.length > 0) {
      setInvValidate(true);
    } else {
      uploadAdditioalDocumentFile(
        new File([blob], 'Vendor_Financing_Report.xlsx', { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 
        setFormState,
        setAttchmentLoader,
        "additional_Docs",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        dataObject[0],
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
      setWaitMessage("Wait... Invoices are being send");
      setSendloader(true);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${
          process.env.REACT_APP_API_URL
        }/api/VFPayments/SentToTreasury?invoices=${treasuryState.invoices.toString()}&treasury=${
          treasuryState.treasury.ReferenceProp1
        }&remarks=${treasuryState.remarks}&lcId=${selectedLC?.lC_Id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          getInvoices();
          setSumNetAmount(0);

          setTreasuryState({ ...treasuryState, invoices: [] });
          setSendloader(false);
          setWaitMessage("");
          setSuccessMessage("Sent to Treasury Successfully");
          setTreasuryState((treasuryState) => ({
            ...treasuryState,
            remarks: "",
          }));
          setInvValidate(false);
          setValidateTresaury(false);
          updateVendorFinancing();
        })
        .catch((error) => {
        
          setSendloader(false);
        });
    }
  };
  const additionalAttachmentRef = useRef(null);
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  const TreasuryHandler = (e) => {
    const { name, value } = e.target;
    setTreasuryState((treasuryState) => ({
      ...treasuryState,
      [name]: value,
    }));
  };
  useEffect(() => {
    getInvoices();
    // setDocError("")
  }, [sentToTreasury]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };

  const handleLCChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      LCPageNo: newPage + 1,
    }));
  };

  const handleLCChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      LcRowsOfPage: event.target.value,
    }));
    // setPage(0);
  };

  const UnBatch = () => {
    console.log(treasuryState, "batch ho")
    console.log(sumNetAmount, "sumNetAmount")
    if (treasuryState.invoices.length == 0) {
      setInvValidate(true);
    } else {
      setSendloader(true);
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${
          process.env.REACT_APP_API_URL
        }/api/VFPayments/Unbatch?invoices=${treasuryState.invoices.toString()}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        },
      };

      axios
        .request(config)
        .then((response) => {

          let config = {
            method: "put",
            url: `${process.env.REACT_APP_API_URL}/api/VendorFinancing/UpdateVendorFinancing?lcId=${treasuryState?.LC_Id}&utilizesAmount=${-(sumNetAmount)}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          };
          axios
            .request(config)
            .then((response) => {
              setSuccessMessage("Invoices Unbatch Successfully");
              setTreasuryState({ ...treasuryState, invoices: [] });
              setInvValidate(false);
              setSendloader(false);
              getInvoices();
            })
            .catch((error) => {
              console.log(error, "error");
            });
          
        })
        .catch((error) => {
          setSendloader(false);
        });
    }
  };

  useEffect(() => {
    if (sentToTreasury === "yet to be sent to Treasury") {
      if (formState?.vendor_Code?.Vendor_Code) {
        const newFormState = {
          ...formState,
          Vendor: formState?.vendor_Code,
          PageNo: formState?.LCPageNo,
          RowsOfPage: formState?.LcRowsOfPage,
        };

        setLcsLoading(true);
        getLcsLandingPage(setLcs, setLcsLoading, newFormState, setLCCount);
      }
    } else {
      setLcs([]);
    }
  }, [formState?.vendor_Code, sentToTreasury]);

  useEffect(() => {
    const newFormState = {
      ...formState,
      Vendor: formState?.vendor_Code,
      PageNo: formState?.LCPageNo,
      RowsOfPage: formState?.LcRowsOfPage,
    };

    if (formState?.vendor_Code?.Vendor_Code) {
      setLcsLoading(true);
      getLcsLandingPage(setLcs, setLcsLoading, newFormState, setLCCount);
    }
  }, [formState?.LCPageNo, formState?.LcRowsOfPage, formState?.Generic]);
  useEffect(() => {
    getBankDetail(null, setBankDetails, setBankDetailsLoading);
  }, []);

  useEffect(() => {
    if (sentToTreasury === "yet to be sent to Treasury") {
      if (formState?.vendor_Code !== "" && formState?.vendor_Code !== null) {
        if (vendorLcs?.length > 0) {
          setLcMessage("");
        } else if (vendorLcs?.length <= 0) {
          setLcMessage("No Lc found for this vendor");
        }
      } else if (formState?.vendor_Code === null) {
        setLcMessage("");
        setLcs([]);
      }
    }
  }, [vendorLcs, formState?.vendor_Code, sentToTreasury]);

  const selectCheckBox = (event, item) => {
    const invoiceAmount = sumNetAmount;
    const newSelectedId =
      selectedCheckBoxId === item?.lC_Id ? null : item?.lC_Id;

      setSelectedLCAmount(newSelectedId)
    setSelectedCheckBoxId(newSelectedId);

    if (event?.target?.checked) {
      if (item?.available_Amount >= invoiceAmount) {
        setSelectedLC(item);
        setLcMessage("");
        if (sumNetAmount > 0) {
          setProceed(true);
        }
      } else {
        setLcMessage("Please select an other LC");
        setProceed(false);
        setSelectedLC(item);
      }
    } else {
      setSelectedLC([]);
    }
  };

  useEffect(() => {
    if (
      sumNetAmount > 0 &&
      Object.keys(selectedLC)?.length > 0 &&
      selectedLC?.available_Amount >= sumNetAmount
    ) {
      setProceed(true);
      setLcMessage("");
    } else {
      setProceed(false);
      setLcMessage("");
    }

    if (selectedLC?.available_Amount < sumNetAmount) {
      setLcMessage("Please select an other LC");
      setProceed(false);
    }
  }, [selectedLC, sumNetAmount]);

  return (
    <Card style={{ marginLeft: "20px" }}>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={sendloader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "1px 20px",
            backgroundColor: "#031C30",
            color: "white",
            height: "62px",
          }}>
          <Grid container justifyContent="space-between">
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <h4>Vendor Financing Payments / Vendor Pre Payments</h4>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}>
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form
        // onSubmit={(e) => submitHandler(e)}
        >
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl component="fieldset">
                {/* <FormLabel
                  required
                  // classes={{ asterisk: classes.asterisk }}
                  id="demo-row-radio-buttons-group-label"
                >
                  <b>Treasury</b>
                </FormLabel> */}
                <Typography>
                  <span className={classes.asterisk}>*</span>
                  Treasury:
                </Typography>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={sentToTreasury}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) => {
                    setsentToTreasury(e.target.value);
                  }}>
                  <FormControlLabel
                    value="sent to Treasury"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#C5C7CD",
                          "&.Mui-checked": {
                            color: "#0095DA",
                          },
                        }}
                      />
                    }
                    label="Sent to treasury"
                  />
                  <br />
                  <FormControlLabel
                    value="yet to be sent to Treasury"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#C5C7CD",
                          "&.Mui-checked": {
                            color: "#0095DA",
                          },
                        }}
                      />
                    }
                    label="Yet to be sent to treasury"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {sentToTreasury === "yet to be sent to Treasury" && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  <span className={classes.asterisk}>*</span> Clearing
                  Documents:
                </Typography>

                <TextField
                  fullWidth={true}
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                  }}
                  type="text"
                  name="clearingDocuments"
                  value={clearingDoc}
                  onChange={(e) => {
                    setClearingDoc(e.target.value);
                  }}
                  FormHelperTextProps={{
                    className: classes.helperText,
                  }}
                  error={docError ? true : false}
                  helperText={docError}
                />
                {clearingDoc == "" && validate && (
                  <span style={{ color: "red" }}>This field is required!</span>
                )}
              </Grid>
            )}
            {sentToTreasury === "yet to be sent to Treasury" && (
              <Grid item xs={12} sm={12} md={4} lg={5}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{
                    marginLeft: "6px",
                    padding: "9px",
                    marginTop: "17px",
                    height: 35,
                  }}
                  onClick={GenerateDoc}>
                  Generate Documents
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{
                    marginLeft: "6px",
                    padding: "9px",
                    marginTop: "17px",
                    height: 35,
                  }}
                  onClick={DelDoc}>
                  Delete Document
                </Button>
                <CSVLink {...csvReport}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    style={{
                      marginLeft: "6px",
                      padding: "9px",
                      marginTop: "17px",
                      height: 35,
                    }}>
                    Download CSV
                  </Button>
                </CSVLink>
                <Button  
                variant="contained"
                    size="small"
                    color="secondary"
                    style={{
                      marginLeft: "6px",
                      padding: "9px",
                      marginTop: "17px",
                      height: 35,
                    }} 
                  onClick={exportToExcel}>Export VF Report</Button>

              </Grid>
            )}
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <Typography>
                <span className={classes.asterisk}>*</span> Vendor:
              </Typography>
              <VenderCode
                disabled={false}
                setFormState={setFormState}
                formState={formState}
                changeHandler={changeHandler}
                bordered={true}
                user={formState.vendor_Code}
                setvendorblock={setvendorblock}
                setErrAlertMessage={setErrAlertMessage}
              />
            </Grid>

            {sentToTreasury === "sent to Treasury" ? (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  <span className={classes.asterisk}>*</span> Batch Reference:
                </Typography>
                <Autocomplete
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "30px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      marginTop: "-4px", // Adjust this value to move the text up
                      fontSize: 15,
                    },
                  }}
                  id="selectStatus"
                  options={batchRef}
                  size="small"
                  name="batchRef"
                  required
                  value={formState.batchRef}
                  getOptionLabel={(option) =>
                    (option !== "" && `${option?.BatchRef || ""}`) || ""
                  }
                  onChange={(e, newValue) => {
                    let objVendor = {
                      target: {
                        name: "batchRef",
                        value: newValue,
                      },
                    };
                    changeHandler(objVendor);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name=""
                      required
                      label={formState.batchRef === "" ? "Select a Value" : ""}
                      InputLabelProps={{
                        style: {
                          fontSize: 15, // Adjust this value to decrease the font size
                          marginTop: "-5px", // Adjust this value to move the label up
                        },
                        shrink: false,
                        required: false,
                      }}
                      value={""}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            ) : (
              <>
                {sentToTreasury === "yet to be sent to Treasury" && (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      style={{ paddingRight: "190px" }}>
                      <Typography>
                        <span className={classes.asterisk}>*</span> Treasury
                        Team:
                      </Typography>
                      <Autocomplete
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        id="selectStatus"
                        options={treasuryRef}
                        getOptionLabel={(option) =>
                          (option !== "" && `${option?.ReferenceText || ""}`) ||
                          ""
                        }
                        size="small"
                        name="treasury"
                        required
                        value={treasuryState.treasury}
                        onChange={(e, newValue) => {
                          let objVendor = {
                            target: {
                              name: "treasury",
                              value: newValue,
                            },
                          };
                          TreasuryHandler(objVendor);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="treasury"
                            required
                            value={""}
                            label={
                              treasuryState.treasury === ""
                                ? "Select a Value"
                                : ""
                            }
                            InputLabelProps={{
                              style: {
                                fontSize: 15, // Adjust this value to decrease the font size
                                marginTop: "-5px", // Adjust this value to move the label up
                              },
                              shrink: false,
                              required: false,
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                      {!treasuryState.treasury && validatetreasury && (
                        <span style={{ color: "red" }}>
                          This field is required!
                        </span>
                      )}
                    </Grid>
                  </>
                )}

                {/* <Grid item xs={12} sm={12} md={1} lg={1}>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={3}>
                  <Typography>
                    Additional Document{" "}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <input
                            ref={additionalAttachmentRef}
                            type="file"
                            name="additionalDocIds"
                            required={formState?.additionalDocIds?.length === 0}
                            onChange={(e) =>
                              uploadAdditioalDocumentFile(
                                e,
                                setFormState,
                                setAttchmentLoader,
                                // setAttachInvoiceLoading,
                                "additionalDocIds",
                                additionalAttachmentRef
                                // setDocsrc,setDocPreview
                              )
                            }
                            style={{ width: "209px" }}
                          />

                          {attachmentLoader ? (
                            <CircularProgress size={24} />
                          ) : (
                            ""
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />

                  {formState.additionalDocIds.length > 0 &&
                    formState.additionalDocIds.map((f, index) => {
                      const s = f.split("\\");
                      const ss = s[s.length - 1];
                      // above 2 lines is for get name of file
                      return (
                        <>
                          {f !== "" ? (
                            <IconButton
                              size="small"
                              onClick={() => {
                                const files = formState.additionalDocIds.filter(
                                  (x, i) => {
                                    const n = x.split("\\");
                                    const nn = n[n.length - 1];
                                    return nn !== ss;
                                  }
                                );
                                setFormState((formState) => ({
                                  ...formState,
                                  additionalDocIds: files,
                                }));
                              }}
                            >
                              <Delete color="danger" fontSize="small" />
                              <span style={{ fontSize: "10px" }}>{ss}</span>
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                </Grid> */}
              </>
            )}
          </Grid>

          {/*date submission row*/}
          {sentToTreasury == "yet to be sent to Treasury" && (
            <Grid container spacing={2} mt={0}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
                style={{ paddingRight: "18px" }}>
                <Typography>Clearing Start Date:</Typography>
                <input
                  className={classes.inputField}
                  type="date"
                  max="9999-12-31"
                  value={formState.clearingDateFrom}
                  onChange={(newValue) => {
                    autocompleteChangeHandler(
                      "clearingDateFrom",
                      newValue.target.value,
                      formatDateTimeForBackend(newValue)
                    );
                  }}
                  style={{ height: 13 }}
                />
                {/*<LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={formState.clearingStartDate}
              onChange={(newValue) => {
                autocompleteChangeHandler(
                  "clearingStartDate",
                  formatDateTimeForBackend(newValue)
                );
              }}
              error={false}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  label="Outlined"
                  variant="outlined"
                  {...params}
                  error={false}
                />
              )}
            />
              </LocalizationProvider>*/}
              </Grid>
              {/*{sentToTreasury == "yet to be sent to Treasury" && (
                <Grid
                  item
                  xs={0}
                  sm={0}
                  md={0}
                  lg={1}
                  style={{ paddingRight: "18px" }}
                ></Grid>
              )}*/}
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
                style={{ paddingRight: "18px" }}>
                <Typography>Clearing End Date:</Typography>
                <input
                  className={classes.inputField}
                  type="date"
                  max="9999-12-31"
                  value={formState.clearingDateTo}
                  onChange={(newValue) => {
                    autocompleteChangeHandler(
                      "clearingDateTo",
                      newValue.target.value,
                      formatDateTimeForBackend(newValue)
                    );
                  }}
                  style={{ height: 13 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{ padding: "6px", marginTop: "20px" }}
                  p={4}
                  onClick={getInvoices}>
                  Search
                </Button>
              </Grid>
            </Grid>
          )}
          {sentToTreasury == "sent to Treasury" && (
            <Grid container spacing={2} mt={0}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
                style={{ paddingRight: "18px" }}>
                <Typography>Batch From Date:</Typography>
                <input
                  className={classes.inputField}
                  type="date"
                  max="9999-12-31"
                  value={formState.batchFromDate}
                  onChange={(newValue) => {
                    autocompleteChangeHandler(
                      "batchFromDate",
                      newValue.target.value,
                      formatDateTimeForBackend(newValue)
                    );
                  }}
                  style={{ height: 13 }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
                style={{ paddingRight: "18px" }}>
                <Typography>Batch To Date:</Typography>
                <input
                  className={classes.inputField}
                  type="date"
                  max="9999-12-31"
                  value={formState.batchToDate}
                  onChange={(newValue) => {
                    autocompleteChangeHandler(
                      "batchToDate",
                      newValue.target.value,
                      formatDateTimeForBackend(newValue)
                    );
                  }}
                  style={{ height: 13 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{ padding: "6px", marginTop: "20px" }}
                  p={4}
                  onClick={getInvoices}>
                  Search
                </Button>
              </Grid>
            </Grid>
          )}

          {sentToTreasury === "yet to be sent to Treasury" && (
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Remarks:</Typography>
                <textarea
                  row={5}
                  col={50}
                  fullWidth={true}
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  type="text"
                  name="remarks"
                  value={treasuryState.remarks}
                  onChange={TreasuryHandler}
                  style={commentBox}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  disabled={!proceed}
                  style={{
                    marginLeft: "6px",
                    padding: "9px",
                    marginTop: "20px",
                    height: 32,
                  }}
                  p={4}
                  onClick={PostTreasury}>
                  Send to Treasury
                </Button>
              </Grid>
            </Grid>
          )}
          {sentToTreasury === "sent to Treasury" && (
            <Grid container>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{ padding: "9px", marginTop: "20px" }}
                  p={4}
                  onClick={UnBatch}>
                  Unbatch
                </Button>
              </Grid>
            </Grid>
          )}
          {sentToTreasury === "yet to be sent to Treasury" &&
            vendorLcs?.length > 0 && (
              <Card style={{ width: "50%", margin: "10px 0px" }}>
                <CardBody>
                  <Grid item xs={12} sm={12} md={5} lg={4}>
                    <TextField
                      placeholder="Enter keyword..."
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 30,
                        },
                      }}
                      fullWidth={true}
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      type="text"
                      name="Generic"
                      value={formState.Generic}
                      onChange={(e) => {
                        setFormState((formState) => ({
                          ...formState,
                          Generic: e.target.value,
                        }));
                      }}
                      style={{ marginTop: "-20px" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchOutlinedIcon sx={{ color: "#0095DA" }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid>
                    <TableContainer
                      className={`${classes.tabCon} ${classes.tableStyle}`}
                      sx={{
                        maxHeight: "200px",
                        overflow: "auto",
                        maxWidth: "100%",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }}>
                      <Table
                        aria-label="a dense table"
                        size="small"
                        sx={{
                          height: 40,
                        }}>
                        <TableHead
                          style={{ position: "sticky", top: 0, zIndex: "1" }}>
                          <TableRow sx={{ backgroundColor: "#eff2f4" }}>
                            <TableCell></TableCell>
                            <TableCell
                              sx={{ fontWeight: "bold", color: "#031C30" }}>
                              LC/Bank Reference
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: "bold", color: "#031C30" }}>
                              Bank Name
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: "bold", color: "#031C30" }}>
                              Maturity Period
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: "bold", color: "#031C30" }}>
                              LC  Amount
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: "bold", color: "#031C30" }}>
                              Utilized Amount
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: "bold", color: "#031C30" }}>
                              Balance
                            </TableCell>
                           
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {vendorLcs?.length > 0 &&
                            vendorLcs?.map((item, index) => {
                              return (
                                <TableRow>
                                  <TableCell>
                                    <Checkbox
                                      color="secondary"
                                      checked={
                                        selectedCheckBoxId === item?.lC_Id
                                      }
                                      onChange={(event) => {
                                        selectCheckBox(event, item);
                                      }}></Checkbox>
                                  </TableCell>
                                  <TableCell>
                                    {item?.lC_Bank_Reference_num}
                                  </TableCell>
                                  <TableCell>
                                    {getBankName(
                                      bankDetails,
                                      item?.["bank_Id"]
                                    )}
                                  </TableCell>
                                  <TableCell>{`${item?.maturity_Period} days`}</TableCell>
                                  <TableCell>
                                    {Number(item?.lC_Amount)?.toLocaleString()}
                                  </TableCell>
                                  <TableCell>
                                   {/* {item?.lC_Id == selectedLCAmount ? sumNetAmount : 0} */}

                                   {item?.lC_Id == selectedLCAmount ? Number(item?.utilizes_Amount + sumNetAmount)?.toLocaleString() : Number(item?.utilizes_Amount)?.toLocaleString()  }
                                  </TableCell>
                                  <TableCell>
                                    {item?.lC_Id == selectedLCAmount ? item?.available_Amount - sumNetAmount >0 ? Number(item?.available_Amount - sumNetAmount)?.toLocaleString() : 0 :  Number(item?.available_Amount)?.toLocaleString()}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TablePagination
                      rowsPerPageOptions={[25, 50, 100]}
                      component="div"
                      count={lccount}
                      rowsPerPage={formState.LcRowsOfPage}
                      page={parseInt(formState.LCPageNo) - 1}
                      onPageChange={handleLCChangePage}
                      onRowsPerPageChange={handleLCChangeRowsPerPage}
                    />
                  </Grid>
                </CardBody>
              </Card>
            )}
          {lcLoading ? (
            <Card style={{ width: "50%", margin: "10px 0px" }}>
              <CardBody>
                <Grid>
                  <TableContainer
                    className={`${classes.tabCon} ${classes.tableStyle}`}
                    sx={{
                      maxHeight: "200px",
                      overflow: "auto",
                      maxWidth: "100%",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    }}>
                    <Table
                      aria-label="a dense table"
                      size="small"
                      sx={{
                        height: 40,
                      }}>
                      <TableSkeleton
                        style={{ width: "100%" }}
                        noOfColumns={3}
                        noOfLines={3}
                      />
                    </Table>
                  </TableContainer>
                </Grid>
              </CardBody>
            </Card>
          ) : (
            <>{lcMessage && <h2 style={{ color: "red" }}>{lcMessage}</h2>}</>
          )}

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <VendorFinancingTable
              vendorList={invoices}
              setVendorList={setInvoices}
              loading={invoiceLoading}
              sentToTreasury={sentToTreasury}
              treasuryState={treasuryState}
              setTreasuryState={setTreasuryState}
              sumNetAmount={sumNetAmount}
              setSumNetAmount={setSumNetAmount}
              validate={Invvalidate}
              page={formState.PageNo}
              RowsPerPage={formState.RowsOfPage}
              UnBatch={UnBatch}
            />
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo)}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </form>
        {successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )}
        {waitMessage && (
          <Snackbar
            // anchorOrigin={{
            //     vertical: { vertical },
            //     horizontal: { horizontal },
            // }}
            // TransitionComponent={left}
            open={waitMessage !== ""}
            onClose={() => setWaitMessage("")}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            autoHideDuration={4000}

            // message={<span id="message-id">{message}</span>}
          >
            <Alert
              onClose={() => setWaitMessage("")}
              severity="info"
              sx={{ width: "100%" }}
              variant="filled">
              {waitMessage}
            </Alert>
          </Snackbar>
        )}
        {errorMessage && (
          <>
            {" "}
            <Grid container spacing={0}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />{" "}
              </Grid>
              <Grid item>
                <Typography className={classes.asterisk} ml={1}>
                  {" "}
                  {errorMessage}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default VendorFinancinglandingpage;
